module.exports = __webpack_public_path__ + "static/img/usage-water.4855cdae.png";